const BASE = process.env.REACT_APP_API_URL || '/api';

export async function submitAssessment(formData, apiKey) {
  const res = await fetch(`${BASE}/assess`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-api-key': apiKey },
    body: JSON.stringify({ formData, companyName: formData.companyName }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}
